// @flow
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import ExportToCsv from "../../../global/functions/ExportCsv";
import {
  isMomentBefore,
  isMomentAfter,
  TodaytoEndTimeAppend
} from "../../../global/functions/DateTimeAmend";
import { propComparator } from "../../../global/functions/StringOperations";

type ExportLicenceToCsvPropsType = {
  licences: Array<*>,
  companies: Array<*>,
  companyFilter?: Array<*>,
  dateStartFilter?: Date | null,
  dateEndFilter?: Date | null,
  licenceFilter?: string,
  statusFilter?: string
};

class ExportLicenceToCsv extends Component<ExportLicenceToCsvPropsType, *> {
  getCompanyFromList = (id: string): * => {
    let index = this.props.companies.findIndex((x: *): number => x.id === id);
    let company = this.props.companies[index];
    return [
      company.name,
      company.contactName,
      company.contactEmail,
      company.contactNumber,
      company.parent && company.parent.id
    ];
  };

  render(): * {
    const licences = this.props.licences;

    let csvArray = [
      [
        "Belong to Company",
        "Licence Type",
        "Start Date",
        "Expiry Date",
        "Facebase Name",
        "Number of Faces",
        "Number of Cameras",
        "Distributor Company",
        "Distributor Contact Person",
        "Distributor Contact Email",
        "Distributor Contact Phone",
        "Reseller Company",
        "Reseller Contact Person",
        "Reseller Contact Email",
        "Reseller Contact Phone",
        "End User Company",
        "End User Contact Person",
        "End User Contact Email",
        "End User Contact Phone",
        "Host Id"
      ]
    ];

    let list = [];
    if (licences && this.props.companies) {
      licences.map((licence: *, i: number): * => {
        let display = true;
        if (this.props.companyFilter && this.props.companyFilter.length > 0) {
          if (this.props.companyFilter.indexOf(licence.company.id) < 0) {
            display = false;
          }
        }
        if (this.props.dateStartFilter) {
          if (
            isMomentBefore(licence.createDateOrigin, this.props.dateStartFilter)
          ) {
            display = false;
          }
        }
        if (this.props.dateEndFilter) {
          if (
            isMomentAfter(licence.createDateOrigin, this.props.dateEndFilter)
          ) {
            display = false;
          }
        }
        if (this.props.licenceFilter && this.props.licenceFilter !== "ALL") {
          if (licence.licenceType !== this.props.licenceFilter) {
            display = false;
          }
        }
        if (this.props.statusFilter && this.props.statusFilter !== "ALL") {
          if (this.props.statusFilter === "EXPIRED") {
            if (
              isMomentAfter(licence.expiryDateOrigin, TodaytoEndTimeAppend())
            ) {
              display = false;
            }
          }
          if (this.props.statusFilter === "ACTIVE") {
            if (
              isMomentBefore(licence.expiryDateOrigin, TodaytoEndTimeAppend())
            ) {
              display = false;
            }
          }
        }

        if (display) {
          list.push(licence);
        }
      });

      list.map((item: *): * => {
        let dCompany = "";
        let dPerson = "";
        let dEmail = "";
        let dPhone = "";
        let dId = "";

        let rCompany = "";
        let rPerson = "";
        let rEmail = "";
        let rPhone = "";
        let rId = "";

        let eCompany = "";
        let ePerson = "";
        let eEmail = "";
        let ePhone = "";
        let eId = "";
        let hostIds = [];

        if (item.company.level === "D") {
          [dCompany, dPerson, dEmail, dPhone, dId] = this.getCompanyFromList(
            item.company.id
          );
        } else if (item.company.level === "R") {
          [rCompany, rPerson, rEmail, rPhone, rId] = this.getCompanyFromList(
            item.company.id
          );
          [dCompany, dPerson, dEmail, dPhone, dId] = this.getCompanyFromList(
            rId
          );
        } else if (item.company.level === "E") {
          [eCompany, ePerson, eEmail, ePhone, eId] = this.getCompanyFromList(
            item.company.id
          );
          [rCompany, rPerson, rEmail, rPhone, rId] = this.getCompanyFromList(
            eId
          );
          [dCompany, dPerson, dEmail, dPhone, dId] = this.getCompanyFromList(
            rId
          );
        }

        item.devices.map((device: *): * => {
          hostIds.push(device.hostId);
        });

        let arr = [
          item.company.name,
          item.licenceType,
          item.startDate,
          item.expiryDate.format("DD/MMM/YYYY hh:mm A"),
          item.facebaseName,
          item.facebaseLimit,
          item.noOfStreams,
          dCompany,
          dPerson,
          dEmail,
          dPhone,
          rCompany,
          rPerson,
          rEmail,
          rPhone,
          eCompany,
          ePerson,
          eEmail,
          ePhone
        ];
        arr = arr.concat(hostIds);

        csvArray.push(arr);
      });

      const fileName = `licence-list-${new Date(Date.now()).toLocaleString()}`;

      return (
        <Button
          type="button"
          variant="contained"
          color="primary"
          className="dark-btn"
          onClick={(): Function => ExportToCsv(fileName, csvArray)}
        >
          <CloudDownloadIcon className="light-icon right-margin-5" />
          Export to CSV
        </Button>
      );
    } else {
      return null;
    }
  }
}

export default ExportLicenceToCsv;
